import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Blackbird(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            You find the Blackbird at what is supposed to be a very famous
            human's house. The Blackbird seems to be talking to every single
            bird that passess along, however the Blackbird is getting ignored by
            every single one. You approach it with caution. "He... Hello?" you
            are not sure what you will get as a response.
          </p>
          <p>
            "Hello!? Are you talking to me!?" The Blackbird turns around
            cheerily, and greets you. "Hey! I am the Blackbird. Omg I can't
            believe you're talking to me and not ignoring me Omg I'm so happy
            someone is listening to what I have to say Omg!" You are taken aback
            by this. You never expected it to be so... Happy.
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Why are you trying to talk to other birds?
            </button>
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              What do you think of Liverpool
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "I am here today preaching about the word of our beloved Pigeon
            Champion, did you know that the other folk will be getting SO MANY
            POINTS unless we do something?"
          </p>
          <p> You respond in a quiet tone: "No."</p>
          <p>
            {" "}
            "Well I guess you have questions and that's great because I have all
            the answers! Ask away!" the Blackbird is overly excited and you are
            not in the mood.
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              What are those points you're talking about?
            </button>
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              What do you think of Liverpool
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Ah. Well, I represent the Bird Folk's voice. I got this role after
            the pigeon got the role of Champion. I am required to be at almost
            all meetings due to this role, making me one of the most important
            people in the Folk. As such I just wish that there was less noise in
            the city so my voice could be heard LOUD AND CLEAR!" the Blackbird
            doesn't stop to catch its breath. "Actually now that I think about
            it that would be a great Incident Marker so MORE POINTS FOR US!" the
            Blackbird is getting too much.
          </p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              The Pigeon needs to talk to you
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Well if my Champion calls, I will be there flying! I'm on it! Like
            a Hawk! You know what I mean?" the Blackbird flies away, but before
            you can rest from its constant chattering it flies back to you. "I
            forgot to say! Would you mind keeping on the sharing job by placing
            some incident markers in the area? IT'S SO NOISY HERE ISN'T IT!!!?
            Byeeeeee".
          </p>
          <p>And the Blackbird left you, at last, alone. But with a task.</p>
          <p>Looks like it's time to place an incident marker...</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "How can you be part of the Bird Folk and not know about points?!
            POINTS are very trendy right now - we get one point per incident
            marker, and then depending on how good the information we provide
            is... WE CAN MAKE SO MANY POINTS!" the Blackbird starts flying
            around in excitement.
          </p>

          <p>
            {" "}
            "You just need to fill this map with Incident Markers and we'll win.
            We'll be the FOLK TO RUN THEM ALLLLLL!" the non-humans around the
            street are staring at you too dying of cringe.
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              The Pigeon needs to talk to you
            </button>
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              What do you think of Liverpool?
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Blackbird;
